import { render, staticRenderFns } from "./Que1.vue?vue&type=template&id=dfe6d910&scoped=true&"
import script from "./Que1.vue?vue&type=script&lang=js&"
export * from "./Que1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe6d910",
  null
  
)

export default component.exports